module.exports = __webpack_public_path__ + "99e7752f6dd4cb2bb563e916f2330369.svg";